<template>
  <div>        
    <div>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Empresa</label>
                <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                    @change="listarCentrosCustos"/>
            </div>
                <div class="p-field p-col-12 p-md-6">
                <label>Centro de custo</label>
                <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                    dataKey="keyRefId" :filter="true" :showClear="true"/>
            </div>                               
        </div> 
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label>Data início</label>
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Data final</label>
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
            </div>
            <div class="p-field p-col-0">
                <label style="color:#ffffff">.</label>  
                <Button label="Buscar" icon="pi pi-search" @click="listar"/>
            </div> 
        </div>
        <DataTable :value="ocorrencias" :filters="filtro" :paginator="true" :rows="10"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
            class="p-datatable-sm p-datatable-striped">
            <template #header>
                <div class="table-header">	
                    <div class="p-d-flex p-jc-end">			
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                        </span>
                    </div>
                </div>
            </template>
            <Column field="crachaFuncionario" header="Crachá" sortable></Column>
            <Column field="nomeFuncionario" header="Nome" sortable></Column>
            <Column field="justificativa" header="Justificativa" sortable></Column>
            <Column field="dia" header="Data" sortable></Column>   
            <Column>
                <template #body="slotProps">
                    <Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
                    <Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>							
                </template>
            </Column>         
        </DataTable> 

        <Dialog :visible.sync="exibirDialogEditar" header="Editar Ocorrência" :modal="true" class="p-fluid" :style="{width: '500px'}">			
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Funcionário</label>
                    <InputText v-model="funcionario.nome" readonly/>
                </div>                      
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Justificativa</label>
                    <Dropdown v-model.number="idJustificativaSelecionada" :options="justificativas" optionLabel="descricao" 
                        optionValue="id" dataKey="id" :filter="true" placeholder="Selecione" appendTo="body"/>
                </div>                      
            </div>
            <label>Abrangência</label>
            <div class="p-formgroup-inline p-mt-2">
                <div class="p-field-checkbox">
                    <Checkbox v-model="ocorrenciaEditar.abrangeFaltas" :binary="true"/>
                    <label>Falta</label>
                </div>
                <div class="p-field-checkbox">
                    <Checkbox v-model="ocorrenciaEditar.abrangeFaltaMarcacao" :binary="true"/>
                    <label>Falta de marcação</label>
                </div>
                <div class="p-field-checkbox">
                    <Checkbox v-model="ocorrenciaEditar.abrangeAtrasos" :binary="true"/>
                    <label>Atraso</label>
                </div>
                <div class="p-field-checkbox">
                    <Checkbox v-model="ocorrenciaEditar.abrangeSaidaAntecipada" :binary="true"/>
                    <label>Saída antecipada</label>
                </div>
                <div class="p-field-checkbox">
                    <Checkbox v-model="ocorrenciaEditar.abrangeExcessoRefeicao" :binary="true"/>
                    <label>Excesso no int. da refeição</label>
                </div>							
            </div>              
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Data</label>                    
                    <InputText v-model="ocorrenciaEditar.dia" readonly/>				
                </div>              
            </div>				
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                <Button label="Salvar" icon="pi pi-check" @click="salvar"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Excluir ocorrência?</span>
                <p>
                    <br/>
                    Funcionário: <b>{{ ocorrenciaSelecionada.nomeFuncionario }}</b><br/>
                    Justificativa: <b>{{ ocorrenciaSelecionada.justificativa }}</b><br/>
                    Data: <b>{{ ocorrenciaSelecionada.dia}}</b>
                </p>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
            </template>
        </Dialog>

    </div>
  </div>
</template>

<script>
import CentroCustoService from '@/service/CentroCustoService';
import OcorrenciaService from '@/service/OcorrenciaService';
import ControlePontoService from '@/service/ControlePontoService.js';
import Ocorrencia from '@/model/Ocorrencia';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    ocorrenciaService: null,
    centroCustoService: null,
    data() {
        return {
            exibirDialogConfirmarExcluir: false,
            exibirDialogEditar: false,
            ocorrenciaSelecionada: {id: null, nomeFuncionario: '', data: null},
            ocorrenciaEditar: new Ocorrencia(),
            idJustificativaSelecionada: null,
            justificativas: [],
            funcionario: {nome: ''},
            permissaoEditar: false,
			permissaoExcluir: false,
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            cnpjs: [],
            centrosCustos: [],
            dataInicio: new Date(),
            dataFinal: new Date(),
            ocorrencias: [],
            filtro: {},
            localeCalendarBR: localeCalendarBR,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),
        /**
         * 
         */
        salvar() {
            if(!this.ocorrenciaEditar.abrangeFaltas 
                && !this.ocorrenciaEditar.abrangeAtrasos 
                && !this.ocorrenciaEditar.abrangeSaidaAntecipada
                && !this.ocorrenciaEditar.abrangeExcessoRefeicao 
                && !this.ocorrenciaEditar.abrangeFaltaMarcacao) {
                exibirMensagemSis(this, 'Selecione uma abrangência', true);
                return;
            }
            let justificativa = null;
            for(let i =0; i < this.justificativas.length; i++) {
                if(this.idJustificativaSelecionada == this.justificativas[i].id) {
                    justificativa = {...this.justificativas[i]};
                    break;
                }
            }
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let ocorrencia = {...this.ocorrenciaEditar};
            ocorrencia.dia = this.formatarData(this.ocorrenciaEditar.dia);
            let requisicao = {  
                cnpj: cnpjSelecionado,
                ocorrencia: ocorrencia,
                funcionario: {
                    id: this.funcionario.id,
                    nome: this.funcionario.nome,
                    cracha: this.funcionario.cracha,
                    pis: this.funcionario.pis
                },              
                justificativa: justificativa, 
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.ocorrenciaService.alterar(requisicao)
            .then(resp => {  
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                } 
                this.fecharModal();
                this.listar();
                if(resp.data instanceof Array && resp.data.length > 0) {
                    let novaRequisicao = {
                        mes: resp.data[0].mes,
                        ano: resp.data[0].ano,
                        dataInicio: resp.data[0].dataInicio,
                        dataFinal: resp.data[0].dataFinal,
                        cnpj: cnpjSelecionado,
                        funcionario:  {
                            id: requisicao.funcionario.id,
                            nome: requisicao.funcionario.nome,
                            pis: requisicao.funcionario.pis
                        },      
                        usuarioRequisicao: {...this.getDadosRequisicao()},          
                    };
                    this.calcularPeriodoEditado(novaRequisicao);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        excluir() {
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let funcionario = {
                nome: this.ocorrenciaSelecionada.nomeFuncionario,
                id: this.ocorrenciaSelecionada.idFuncionario,
                pis: this.ocorrenciaSelecionada.pisFuncionario
            }
            let ocorrencia = {...this.ocorrenciaSelecionada};
            ocorrencia.dia = this.formatarData(ocorrencia.dia);
            let requisicao = {  
                cnpj: cnpjSelecionado,
                funcionario: funcionario,
                ocorrencia: ocorrencia,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.ocorrenciaService.excluir(requisicao)
            .then(resp => {             
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                }                         
                this.limparExcluir();
                this.listar();
                if(resp.data instanceof Array && resp.data.length > 0) {
                    let novaRequisicao = {
                        mes: resp.data[0].mes,
                        ano: resp.data[0].ano,
                        dataInicio: resp.data[0].dataInicio,
                        dataFinal: resp.data[0].dataFinal,
                        cnpj: cnpjSelecionado,
                        funcionario:  {
                            id: funcionario.id,
                            nome: funcionario.nome,
                            pis: funcionario.pis
                        },      
                        usuarioRequisicao: {...this.getDadosRequisicao()},          
                    };
                    this.calcularPeriodoEditado(novaRequisicao);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
         calcularPeriodoEditado(requisicao) {           
            this.controlePontoService.calcularPeriodoEditado2(requisicao)
            .then()
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        listar() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {               
                this.centrosCustos.forEach(ctc => {
                    if(ctc.id != null) {
                        idsCentrosCustos.push(ctc.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }            
            let requisicao = {  
                idsCentrosCustos: idsCentrosCustos,            
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.ocorrenciaService.listar(requisicao)
            .then(resp => {                    
                this.ocorrencias = resp.data;    
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        editar(ocorrencia) {		
			let requisicao = {
				idOcorrencia: ocorrencia.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.ocorrenciaService.buscar(requisicao)
            .then(resp => {	
                this.ocorrenciaEditar = resp.data.ocorrencia;                   
                this.funcionario = resp.data.funcionario;                    
                this.idJustificativaSelecionada = resp.data.justificativa.id;
                this.justificativas = resp.data.justificativas;
                this.exibirDialogEditar = true;				
            })
            .catch(erro => {exibirMensagem(this, erro)});
		},
        /**
         * 
         */
         listarCnpjs() {
            if(this.cnpjs.length > 0) {
                return;
            }
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            centroCusto['keyRefId'] = Date.now();
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        listarCentrosCustos() {
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {   
                let dataKey = 1;               
                resp.data.forEach(ct => {
                    ct['keyRefId'] = dataKey++;
                });                     
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                centroCusto['keyRefId'] = Date.now();
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);                    
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        /**
         * 
         */
		confirmarExcluir(ocorrencia) {
			this.ocorrenciaSelecionada = ocorrencia;
			this.exibirDialogConfirmarExcluir = true;
		},
        /**
         * 
         */
		limparExcluir() {
			this.ocorrenciaSelecionada = {id: null, nomeFuncionario: '', data: null};
			this.exibirDialogConfirmarExcluir = false;
		},
        /**
         * 
         */
		fecharModal() {
            this.ocorrenciaEditar = new Ocorrencia();
			this.exibirDialogEditar = false;
		},        
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        /**
         * 
         */
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoEditar = permissoes.includes(113);
			this.permissaoExcluir = permissoes.includes(110);				
		}
    },
    created() {
        this.controlePontoService = new ControlePontoService();
        this.ocorrenciaService = new OcorrenciaService();
        this.centroCustoService = new CentroCustoService();       
    },
    mounted() {
        this.listarCnpjs();
        this.validarPermissoes();
    }
}
</script>

<style>

</style>